import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import * as _ from 'underscore';
import { IPagination } from '../../../../../app.common/modules/common/models';
import { EnumService } from '../../../../../app.common/modules/common/services/enum.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { IClassificationCategoriesValidateComponent } from '../../../../../app.retailer.common/modules/categories/classification-categories-base.component';
import { ClassificationCategoriesService } from '../../../../../app.retailer.common/modules/categories/classification-categories.service';
import { AccountService } from '../../../account/account.service';
import { ClassificationCategoryListItem, StoreInventoryResponse } from '../../../core';
import { IRetailerRootScope } from '../../../core/models';
import { ShopService } from '../../../places/shop.service';
import { InventoryService } from '../../inventory.service';

interface IDataPagination extends IPagination {
    data: any[];
    filter: string;
    setDefault: () => void;
    setData: () => void;
    applyFilter: () => any[];
}

interface IInventoryPagination {
    categories: IDataPagination;
    categoryBrands: IDataPagination;
}

interface IClassificationCategoryListItem extends ClassificationCategoryListItem {
    type: number;
    selected: boolean;
    logoPurple: string;
    logoWhite: string;
}

class InventoryController {
    public static $inject = ['$rootScope', '$stateParams', '$q', '$timeout',
        'inventoryService', 'classificationCategoriesService', 'shopService',
        'notificationService', 'enumService', '$translate', 'accountService'];

    public model = null;
    public waiting: boolean = true;
    public inventoryform: ng.IFormController;
    public languageId: number;
    public contentLoaded = false;

    public data = {
        shopID: parseInt(this.$stateParams.shopId, 10),
        shop: this.$stateParams.shop,
        inventory: null as StoreInventoryResponse,
        inventoryTemp: null as StoreInventoryResponse,
        classificationCategoriesErrors: null as IClassificationCategoriesValidateComponent,
        isShopping: false,
        init: async () => {
            const i = this.data;
            if (isNaN(i.shopID)) {
                this.notificationService.showErrorMessage();
                this.waiting = false;
                return;
            }
            this.notificationService.showWaitingMessage();

            try {
                const response = await this.$q.all([this.inventoryService.get(i.shopID), this.shopService.getStore(i.shopID)]);
                i.inventory = response[0];
                i.shop = response[1];
                i.inventoryTemp = angular.copy(i.inventory);
                i.adaptData();
                this.$timeout(() => {
                    this.notificationService.clearAll();
                    this.contentLoaded = true;
                }, 1800);
            } catch (error) {
                this.notificationService.showErrorMessage();
            }
            this.waiting = false;
        },
        adaptData: () => {
            const i = this.data;
            i.isShopping = i.inventoryTemp.BusinessType === this.enumService.BusinessType.Shop;
        },
        changeClassificationCategory: () => {
            return;
        },
        isValidInventory: () => {
            const i = this.data;

            if (this.data.classificationCategoriesErrors && !_.isEmpty(this.data.classificationCategoriesErrors.selectedNoLiveCategories)) {
                const invalidnames = this.data.classificationCategoriesErrors.selectedNoLiveCategories;
                const size = _.size(invalidnames);
                const strName = (size === 1) ? _.first(invalidnames) : _.first(invalidnames, size - 1).join(', ') + this.$translate.instant('and') + _.last(invalidnames);
                const errorMassage = this.$translate.instant('please_select_at_least_one_category_for') + strName;
                this.notificationService.showErrorMessage({ body: errorMassage });
                return false;
            }
            return true;
        }
    };

    constructor(
        private $rootScope: IRetailerRootScope,
        private $stateParams: StateParams,
        public $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private inventoryService: InventoryService,
        private classificationCategoriesService: ClassificationCategoriesService,
        private shopService: ShopService,
        private notificationService: NotificationService,
        private enumService: EnumService,
        private $translate: angular.translate.ITranslateService,
        private accountService: AccountService
    ) {
        this.languageId = accountService.userData.languageID;
    }

    public async $onInit() {
        this.init();
    }

    public saveInventory = async () => {
        if (this.data.isValidInventory()) {
            this.notificationService.showWaitingMessage();
            this.waiting = true;
            try {
                await this.inventoryService.save(this.data.shopID, this.data.inventoryTemp);
                this.notificationService.showSuccessMessage();
                this.$timeout(() => {
                    this.$rootScope.$state.go('app.shop', { id: this.data.shopID });
                }, 1000);
            } catch (error) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    private init = async () => {
        try {
            await this.data.init();
        } catch (error) {
            return;
        }
    }
}

angular.module('naut').component('inventory', {
    template: require('./inventory.html'),
    controller: InventoryController,
    controllerAs: 'vm'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/inventory/inventory.component.ts